<div [ngClass]="{'subBlockContainer': !setFullWindow , 'subBlockContainer_full':setFullWindow} ">
  <div class="pageTitle">
    {{tittle}}
    <i class="material-icons pullfloat-right" (click)="close()">close</i>

  </div>
  <div class="subBlockContent">


    <!-- layout  -->


    <div class="row">
      <div class="col-md-6 col-sm-12">
        <div class="board">
          <h4>THE BOARD</h4>
          David Dicker
          <br> Fiona Brown
          <br>Vladimir Mitnovetski
          <br>Mary Stojcevski
          <br>Michael Demetre
          <br>Ian Welch
        </div>
      </div>
      <div class="col-md-6 col-sm-12">
        <div class="detail-center">

          <h4> DICKER DATA INVESTOR CENTER </h4>Dicker Data Limited ( ASX:DDR ) is a leading computer hardware distributor located
          in Sydney and has been operating since 1978. On 24 January 2011 Dicker Data was successfully admitted to the official
          list of the Australian Securities Exchange. The Dicker Data investor page is a dedicated resource for our shareholders
          and investors. From here you can access ASX announcements and obtain information on our share price and financial
          performance.
        </div>
      </div>
    </div>

    <div class="row" style="margin-top: 20px">
      <div class="col-md-6 col-sm-12">
        <div #googleChartDemo style="width: auto">

        </div>

        <app-announcements></app-announcements>
      </div>
      <div class="col-md-6 col-sm-12">
        <div class="detail-center asx-center">
          <h4>ASX INFORMATION</h4>
          For further information, including the current share price and trading history please click here.
          <br> Investor Contacts
          <br>
          <a href="#"> Dicker Data Investor Contact Details</a>
          Governance & Policy
          <br>
          <a href="#"> Board Charter</a>
          <a href="#">Code of Conduct (Officers)</a>
          <a href="#">Code of Conduct (Stakeholders)</a>
          <a href="#">Continuous Disclosure Policy</a>
          <a href="#">Corporate Governance Statement</a>
          <a href="#">Dividend Reinvestment Plan</a>
          <a href="#">Securities Trading Policy</a>
          <a href="#">Employee Share Plan</a>
          ANNUAL REPORTS:
          <a href="#">Financial Year 2017 (FY17)</a>
          <a href="#">Financial Year 2016 (FY16)</a>
          <a href="#">Financial Year 2015 (FY15)</a>
          <a href="#">Financial Year 2014 (FY14)</a>
          <a href="#">Financial Year 2014 (FY14)</a>
          <a href="#">Financial Year 2013 (FY13)</a>
          <a href="#">Financial Year 2012 (FY12)</a>
          <a href="#">Financial Year 2011 (FY11)</a>
        </div>
      </div>
    </div>


  </div>
  <div #entry>

  </div>
